import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import { Icon } from 'appSrc/components/UI';
import ProductCard from '../ProductCard';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

const carouselOptions = {
    infinite: false,
    swipeToSlide: true,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: false,
    responsive: [
        {
            breakpoint: 840,
            settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

class SideCarousel extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            atBeginning: true,
            atEnd: false,
            index: 0,
            total: 0,
        };
    }
    componentDidMount() {
        if( this._slider ) {
            var atZero = true;
            var total = this._slider.props.children.length;
            var overLimit = this._slider.props.slidesToScroll >= total;
            if( atZero && overLimit ) {
                this.setState( { atBeginning: true, atEnd: true, total: total } );
            } else if( atZero ) {
                this.setState( { atBeginning: true, atEnd: false, total: total } );
            } else if( overLimit ) {
                this.setState( { atBeginning: false, atEnd: true, total: total } );
            } else {
                this.setState( { atBeginning: false, atEnd: false, total: total } );
            }
        }
    }
    slickNext = () => {
        this._slider && this._slider.slickNext();
    }
    slickPrev = () => {
        this._slider && this._slider.slickPrev();
    }
    beforeChange = ( oldIndex, newIndex ) => {
        var atZero = newIndex == 0;
        var total = this._slider.props.children.length;
        var overLimit = newIndex + this._slider.props.slidesToScroll >= total;
        if( atZero && overLimit ) {
            this.setState( { atBeginning: true, atEnd: true, index: newIndex, total: total } );
        } else if( atZero ) {
            this.setState( { atBeginning: true, atEnd: false, index: newIndex, total: total } );
        } else if( overLimit ) {
            this.setState( { atBeginning: false, atEnd: true, index: newIndex, total: total } );
        } else {
            this.setState( { atBeginning: false, atEnd: false, index: newIndex, total: total } );
        }
    }



    render() {
        const { products } = this.props;
        const { index, total } = this.state;

        var iconSize = 65;
        if( this.props.screenType === 'mobile' ) {
            iconSize = 40;
        }

        return (
            <div className={ `${ style.sideCarousel } ${ this.props.className }`.trim() }>
                <div className={ style.controls }>
                    <div className={ style.buttons }>
                        <Icon source='customSvg' icon='carousel-prev' size={ iconSize } onClick={ this.slickPrev }
                        disabled={ this.state.atBeginning } />
                        <Icon source='customSvg' icon='carousel-next' size={ iconSize } onClick={ this.slickNext }
                        disabled={ this.state.atEnd } />
                    </div>
                    <div className={ style.place }>
                        { index + 1 }/{ total }
                    </div>
                </div>
                <div className={ style.carouselWrapper }>
                    <Slider { ...carouselOptions } ref={ ( el ) => { this._slider = el; } }
                    beforeChange={ this.beforeChange }>
                        { products.map( ( product ) => ( <ProductCard product={ product } key={ product.desireid } /> ) ) }
                    </Slider>
                </div>
            </div>
        );
    }
}
SideCarousel.propTypes = {
    className: PropTypes.string,
    carouselOptions: PropTypes.object,
};
SideCarousel.defaultProps = {
    className: '',
    carouselOptions: {},
    products: [],
};

const mapStateToProps = ( state ) => {
    return {
        screenType: state.screenSize.type,
    };
};

export default connect( mapStateToProps )( SideCarousel );
